import { useEffect, useRef, useState } from 'react'

import {
  addDragListeners,
  createDragHandlers,
  removeDragListeners,
} from './useDraggingOver.utils'

export function useDraggingOver() {
  const [isDragging, setIsDragging] = useState(false)

  const componentRef = useRef(null)
  const handlersRef = useRef(null)
  const draggingStateRef = useRef(false)

  function handleDropFile() {
    setIsDragging(false)
  }

  function handleDragOver() {
    setIsDragging(true)
  }

  function setDragging(next) {
    if (draggingStateRef.current === next) {
      return
    }

    draggingStateRef.current = next
    setIsDragging(next)
  }

  function detach(node) {
    if (!node || !handlersRef.current) {
      return
    }

    removeDragListeners(node, handlersRef.current)
    handlersRef.current = null
  }

  function attach(node) {
    const handlers = createDragHandlers(node, setDragging, draggingStateRef)

    addDragListeners(node, handlers)
    handlersRef.current = handlers
  }

  function ref(node) {
    if (componentRef.current === node) {
      return
    }

    if (componentRef.current) {
      detach(componentRef.current)
    }

    componentRef.current = node

    if (node) {
      attach(node)
    }
  }

  //remove listeners
  useEffect(() => () => detach(componentRef.current), [detach])

  return { handleDragOver, handleDropFile, isDragging, ref }
}
